/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import SelectCity from "./SelectCity.container";

export default SelectCity;
